function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 11 11",
  className: (styles["hbs-cta-link__icon"] || "hbs-cta-link__icon") + " " + (styles["hbs-cta-link__icon--arrow"] || "hbs-cta-link__icon--arrow"),
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("path", {
  className: styles["arrow-right-path"] || "arrow-right-path",
  fill: "currentColor",
  d: "M11 5.5L5.444 11 4.333 9.9l3.715-3.677H0V4.667h7.936L4.333 1.1 5.444 0 11 5.5z"
})));